import React, { Component, Fragment } from 'react';
import { translate } from '../../Services/translation';

export default class ProductInformation extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.toggleDetailedInfo = this.toggleDetailedInfo.bind(this);
        this.descRef = React.createRef();

        this.state = {
            showDetailedInfo: false,
            showButton: false,
            showMore: false,
        }

        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        let element = this.descRef.current;

        if (element && (element.offsetHeight < element.scrollHeight ||
            element.offsetWidth < element.scrollWidth)) {
            this.setState(() => ({
                showButton: true
            }));
        }
    }

    toggle() {
        this.setState(() => ({
            showMore: !this.state.showMore
        }));
    }


    toggleDetailedInfo(e) {
        e.preventDefault();

        this.setState({
            showDetailedInfo: !this.state.showDetailedInfo
        }, () => {
            //Scroll to detailed info section
            const element = this.ref.current;
            if (this.state.showDetailedInfo && element) {
                const headerHeight = document.querySelector(".js-header").offsetHeight;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - (headerHeight + 16);

                window.scrollTo({ top: elementPosition, behavior: "smooth" });
            }
        });
    }

    render() {
        const props = this.props;

        return (

            <section className="product-information js-product-info">
                <div className="product-information__column product-information__column--description">
                    {props.informationTemplate != null && props.informationTemplate.length > 0 &&
                        <Fragment>
                            <div className="product-information__column-inner">
                                <div className="product-information__content">
                                    <h4 className="product-information__title">
                                        {translate('product.description')}
                                    </h4>                                                                            
                                    <div className={`main-image__description js-clamp ${this.state.showMore ? "" : "line-clamp-desc"}`} ref={this.descRef}>
                                        <span className="product-detail__description" dangerouslySetInnerHTML={{ __html: props.productDescription }} ></span>
                                        {props.informationTemplate.find(x => x.name == "Produkt Text" && x.value !== null && x.value !== "") != null &&
                                         <span className="product-detail__longer-description" dangerouslySetInnerHTML={{ __html: props.informationTemplate.find(x => x.name == "Produkt Text" && x.value !== null && x.value !== "").value }} />}
                                    </div>                                                                            
                                    {this.state.showButton &&
                                        <button className={this.state.showMore ? "main-image__show-less" : "main-image__show-more"} 
                                        onClick={() => this.toggle()}>{this.state.showMore ? translate('main.image.read.less') : translate('main.image.read.more')}
                                            < svg className="arrow main-image__show-more-icon">
                                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-down"></use>
                                            </svg>
                                        </button>
                                    }
                                    {props.detailedSpecification && props.detailedSpecification.hasInfo &&
                                        <Fragment>
                                            <a href="#detailed-specification" onClick={this.toggleDetailedInfo} className="product-information__more-info" ref={this.ref}>
                                                {props.detailedSpecification.tabName}
                                                <svg className={`product-information__arrow ${this.state.showDetailedInfo ? "product-information__arrow--up" : ""}`}><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-down"></use></svg>
                                            </a>
                                            {this.state.showDetailedInfo &&
                                                <div className="product-information__detailed-info" id="detailed-specification">
                                                    <div dangerouslySetInnerHTML={{ __html: props.detailedSpecification.text }} />
                                                    {props.detailedSpecification.image != null &&
                                                        <figure className="product-information__figure" dangerouslySetInnerHTML={{ __html: props.detailedSpecification.imageUrl }} />
                                                    }
                                                </div>

                                            }
                                        </Fragment>
                                    }

                                </div>
                            </div>
                        </Fragment>
                    }
                </div>

                {props.productFieldValue && props.productFieldValue.length > 0 &&
                    <div className="product-information__column product-information__column--specification">
                        <div className="product-information__column-inner">
                            <div className="product-information__content">
                                <h4 className="product-information__title">
                                    {translate('product.specification')}
                                </h4>
                                <ul className="product-information__table">
                                    {/* no alt support */}
                                    {props.productFieldValue.filter(x => x.name != "PdfExternalLink" && x.name != "PdfInternalLink").map((item) => (
                                        item.name.indexOf("Bild") > -1 ? <li key={item.name}><img src={item.value} /></li>
                                            : item.value != "0 cm" &&
                                            <li key={item.name}>
                                                <span className="product-information__field-name">
                                                    {item.name}:
                                                </span>
                                                <span dangerouslySetInnerHTML={{ __html: item.value }} />
                                            </li>

                                    ))}
                                </ul>
                                <div>
                                    {props.productFieldValue.filter(x => x.name == "PdfExternalLink"
                                        || x.name == "PdfInternalLink").length > 0 ?
                                        ((props.productFieldValue.filter(x => x.name == "PdfInternalLink") != null && props.productFieldValue.filter(x => x.name == "PdfInternalLink").length > 0) ||
                                            (props.productFieldValue.filter(x => x.name == "PdfExternalLink") != null && props.productFieldValue.filter(x => x.name == "PdfExternalLink").length > 0)) &&
                                        <a className="download-link product-information__download-link"
                                            href={(props.productFieldValue.filter(x => x.name == "PdfInternalLink") != null &&
                                                props.productFieldValue.filter(x => x.name == "PdfInternalLink").length > 0 ?
                                                props.productFieldValue.filter(x => x.name == "PdfInternalLink")[0].value
                                                : props.productFieldValue.filter(x => x.name == "PdfExternalLink")[0].value)} target="_blank">
                                            <svg className="product-information__download-icon">
                                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#download"></use>
                                            </svg>
                                            {translate('product.downloadPdf')}
                                        </a>
                                        : null}

                                </div>
                            </div>
                        </div>
                    </div>
                }
            </section>

        )
    }
}
